import {useEffect, useState} from "react";
import styled, {css} from "styled-components";
import {breakpoints} from "@/styles/sizes";
import Head from "next/head";

const ImageWrapper = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 650px;
  background-image: url(${props => props.imageUrl});
  background-size: cover;
  background-position: center;

    @media only screen and (${breakpoints.mobile}) {
        height:550px;
    }
`;
const IndicatorWrapper = styled.div`
    position: absolute;
    bottom: 30px;
    left:30px;
    display: flex;
    align-items: center;
    gap:10px;
    z-index: 9;
`;
const Indicator = styled.div`
    cursor: pointer!important;
    width: 10px;
    height: 10px;
    background-color: white;
    
    ${({ isActive }) => {
    if(isActive){
        return css`
                    background: transparent;
                    border: 2px solid white;
                `;
    }
}
}
`;


export function HeroCarousel({images, children}){
    const [currentIndex, setCurrentIndex] = useState(0);  // Track current image index

    // Function to update image index every second
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div
            style={{
            }}
            className={'container'}
        >
            <div style={{
                position: 'relative',
            }}>
                <div className={'container'} style={{position: 'relative', overflow:'hidden',}}>
                    <div
                        style={{
                            position:'relative',
                            width:'100%',
                            display: 'flex',
                            transition: 'transform 0.5s ease-in-out',
                            transform: `translateX(${-currentIndex * 100}%)`, // Slide effect
                        }}
                    >
                        <Head>
                            {images.map((item, index) => (
                                <link key={index} rel="preload" href={item.url} as="image" />
                            ))}
                        </Head>
                        {images.map((item, index) => (
                            <ImageWrapper key={index} imageUrl={item?.url} />
                        ))}
                    </div>
                    {
                        images?.length > 1 && <>

                            <IndicatorWrapper>
                                {
                                    images?.map((item,index) => {
                                        return <Indicator
                                            key={index}
                                            isActive={index === currentIndex}
                                            onClick={() => setCurrentIndex(index)}
                                        />;
                                    })
                                }
                            </IndicatorWrapper>
                        </>
                    }

                </div>

                {children}
            </div>
        </div>

    );
}
